import Vue from "vue";
import axios from "axios";
import qs from "qs";
import {ADD_PENDING_URL, UPDATE_PENDING_URL} from "@/store/mutation-types";
import getCookie from "@util/getCookie";//获取cookie里的SSID
axios.interceptors.request.use(function (config) {
  // previousAjaxTimeStamp 字段在 NavBar 轮询紧急推送消息处使用
  let ssid = getCookie('SSID');
  if (window.ssid && ssid !== window.ssid){
    vm.$message.error('登录失效，请重新登录');
    setTimeout(() => {
      window.location.href = '/account-web';
    }, 1000);
    if (!localStorage.menuList) {
      this.$axios.get('/hq-agency/user/menu').then((menu) => {
        if (menu.code === 200) {
          localStorage.setItem('menuList', JSON.stringify(menuList));
          console.log(123);
        }
      });
    } else {
      console.log('无需读取');
    }
    return false;
  } else {
    window.previousAjaxTimeStamp = +new Date();
    let pendingUrls = localStorage.getItem('pendingUrls');
    if (pendingUrls) {
      pendingUrls = JSON.parse(pendingUrls);
      const isLoading = pendingUrls[config.url];
      if (isLoading === true) {
        throw '取消请求';
      } else if (isLoading === false) {
        pendingUrls[config.url] = true;
        localStorage.setItem('pendingUrls', JSON.stringify(pendingUrls));
      }
    }
    return config;
  }
});
axios.interceptors.response.use(function (response) {
  let pendingUrls = localStorage.getItem('pendingUrls');
  if (pendingUrls) {
    pendingUrls = JSON.parse(pendingUrls);
    const isLoading = pendingUrls[response.config.url];
    if (isLoading !== undefined) {
      pendingUrls[response.config.url] = false;
      localStorage.setItem('pendingUrls', JSON.stringify(pendingUrls));
    }
  }
  return response.data;
}, function (error) {
  if (error.response) {
    let pendingUrls = localStorage.getItem('pendingUrls');
    if (pendingUrls) {
      pendingUrls = JSON.parse(pendingUrls);
      const isLoading = pendingUrls[error.response.config.url];
      if (isLoading !== undefined) {
        pendingUrls[error.response.config.url] = false;
        localStorage.setItem('pendingUrls', JSON.stringify(pendingUrls));
      }
    }
    if (error.response.status === 401) {
      // 非线上不做跳转登录页处理
      if (!process || process.env.NODE_ENV === 'production') {
        vm.$message.error('登录失效，请重新登录');
        setTimeout(() => {
          // localStorage.clear();
          // window.location.href = '/account-web';
          localStorage.removeItem('agency_tree');
          localStorage.removeItem('showMTRights');
          localStorage.removeItem('storeRightsMenu');
          localStorage.removeItem('storeRightsDialog');
          localStorage.removeItem('weakPwd');
          localStorage.removeItem('menu');
          localStorage.removeItem('menuList');
          window.location.href = "/metis-login-web/auth/logout";
        }, 1000);
      }
    }
    if (error.response.status === 429) {
      vm.$message.error('请求过于频繁，请稍后再试');
    }
    if ((error.response.status + '').startsWith('50')) {
      vm.$message.error('服务器繁忙，请稍后再试');
    }
  }
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$agency = {};



// WEBPACK FOOTER //
// ./src/components/core/registerAjax.js